import { assertNonNullable } from './utils';

export const findRecursive = <T extends { children?: T[] }>(
  data: T[],
  callback: (item: T, idx: number, data: T[]) => boolean,
): T | undefined => {
  for (let idx = 0; idx < data.length; idx++) {
    const item = data[idx];
    assertNonNullable(item);
    if (callback(item, idx, data)) {
      return item;
    }

    if (item.children?.length) {
      const found = findRecursive(item.children, callback);
      if (found) {
        return found;
      }
    }
  }
  return undefined;
};

export function flatten<T extends { children?: T[] }>(data: T[]): T[];
export function flatten<T extends { children?: T[] }, R>(
  data: T[],
  mapTo: (item: T) => R,
): R[];
export function flatten<T extends { children?: T[] }, R>(
  data: T[],
  mapTo?: (item: T) => R,
) {
  const result: (T | R)[] = [];
  const recursion = (nodes: T[]) => {
    for (const item of nodes) {
      result.push(mapTo ? mapTo(item) : item);
      if (Array.isArray(item.children)) {
        recursion(item.children);
      }
    }
  };
  recursion(data);
  return result;
}
